import { useUrlParameters } from '@nxworkspace/frontend-utils';

export function useHuurcheckUrlParams() {
  const { userid: userId, personaliaid: personaliaId } = useUrlParameters();
  return { userId, personaliaId };
}
